import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const AddIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99967 5.33203V10.6654M10.6663 7.9987H5.33301"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6663 7.9987C14.6663 4.3168 11.6815 1.33203 7.99967 1.33203C4.31777 1.33203 1.33301 4.3168 1.33301 7.9987C1.33301 11.6806 4.31777 14.6654 7.99967 14.6654C11.6815 14.6654 14.6663 11.6806 14.6663 7.9987Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);
export const AddIconMedium: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 8V16M16 12H8"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);
